/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */

import React, { useEffect } from 'react';
import HotelDetailsV2 from './HotelDetailsV2';
import './HotelDetailsPage.scss';
import {
  hideHeaderMenu,
  showHeaderMenu,
} from '../../../shared/helper-utils/appUtils';

function HotelDetailsPage() {
  // useEffect(() => {
  //   hideHeaderMenu();
  //   return () => showHeaderMenu();
  // }, []);
  return (
    <section className="hotel-details-page">
      <HotelDetailsV2 />
    </section>
  );
}

export default HotelDetailsPage;
